import React from 'react';
import CardButton from '../CardButton/CardButton';
import './TutorDaySlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import { View_checklist } from '../../../../../cosmosTracking/cosmosEvents';
import { SOURCE_HOME, directDeepLink } from '../../../util';
import tutorAnimation from '../../../Resources/Slides/indipendence/tutor-the-sale.json';
import Lottie from "react-lottie";

function TutorDaySlide(props) {
	
	const { data, rewardText } = props;
	const tutorAnimationLottie = {
		loop: true,
		autoplay: true,
		animationData: tutorAnimation,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};
	return (
		<div className="slideCard slideCardTutor">
			<div className="cardHeader">
				<Lottie options={tutorAnimationLottie} height={128}></Lottie>
			</div>
			<div className="cardContent">
				<div className="tutorData" onClick={() => {cosmosTrackService(View_checklist);directDeepLink(data?.deeplink, SOURCE_HOME);}} deeplink={data?.deeplink}>
					<img src={data?.orgLogo} width={60} alt="tutor" height={60} />
					<h4>{data?.orgName}</h4>
					{/*<p><img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-local-icon.png" alt="localtionicon" width={16} height={16} /> New Delhi</p>*/}
				</div>
				<CardButton text={'Be the one '}
					className={'btn-action'}
					eventCallback={() => {cosmosTrackService(View_checklist);}}
					deeplink={data?.deeplink}
				/>
			</div>
		</div>
	);
}

export default TutorDaySlide;
